var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.audio)?_c('Object3D',{attrs:{"obj":_vm.audio}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }